// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BenefitLeafletViewViewLeafletEvent
 */
export var BenefitLeafletViewViewLeaflet = function (_a) {
    var benefitType = _a.benefitType;
    return ({
        name: "BenefitLeaflet View ViewLeaflet",
        parameters: {
            cdf_entity: "BenefitLeaflet",
            cdf_action: "View",
            benefit_type: benefitType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see BenefitLeafletViewViewErrorEvent
 */
export var BenefitLeafletViewViewError = function (_a) {
    var benefitType = _a.benefitType;
    return ({
        name: "BenefitLeaflet View ViewError",
        parameters: {
            cdf_entity: "BenefitLeaflet",
            cdf_action: "View",
            benefit_type: benefitType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see BenefitLeafletClickClickPrimaryEvent
 */
export var BenefitLeafletClickClickPrimary = function (_a) {
    var benefitType = _a.benefitType;
    return ({
        name: "BenefitLeaflet Click ClickPrimary",
        parameters: {
            cdf_entity: "BenefitLeaflet",
            cdf_action: "Click",
            benefit_type: benefitType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see BenefitLeafletClickClickSecondaryEvent
 */
export var BenefitLeafletClickClickSecondary = function (_a) {
    var benefitType = _a.benefitType;
    return ({
        name: "BenefitLeaflet Click ClickSecondary",
        parameters: {
            cdf_entity: "BenefitLeaflet",
            cdf_action: "Click",
            benefit_type: benefitType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see BenefitLeafletClickClickDoneEvent
 */
export var BenefitLeafletClickClickDone = function (_a) {
    var benefitType = _a.benefitType;
    return ({
        name: "BenefitLeaflet Click ClickDone",
        parameters: {
            cdf_entity: "BenefitLeaflet",
            cdf_action: "Click",
            benefit_type: benefitType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see BenefitLeafletClickClickLinkEvent
 */
export var BenefitLeafletClickClickLink = function (_a) {
    var benefitType = _a.benefitType;
    return ({
        name: "BenefitLeaflet Click ClickLink",
        parameters: {
            cdf_entity: "BenefitLeaflet",
            cdf_action: "Click",
            benefit_type: benefitType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see BenefitLeafletDismissDismissLeafletEvent
 */
export var BenefitLeafletDismissDismissLeaflet = function (_a) {
    var benefitType = _a.benefitType;
    return ({
        name: "BenefitLeaflet Dismiss DismissLeaflet",
        parameters: {
            cdf_entity: "BenefitLeaflet",
            cdf_action: "Dismiss",
            benefit_type: benefitType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
